import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import MissingImportsReportCriteria from './MissingImportsReportCriteria';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { AppService, Types } from '../../../App/Services/AppService';

@NeoReport("MissingImports",  { category: MaintenanceReportCategories.DataValidationReports})
export default class MissingImportsReport extends Report<MissingImportsReportCriteria>{
    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)
    ) {
        super(MissingImportsReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
            <Neo.GridLayout lg={3} md={3}>
                <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.staticServiceProviderFileGroupingId}
                        bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                        .sort((x,y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                        />
                </Neo.FormGroup>
                <Neo.FormGroup 
                    label={TextConstants.Labels.StartDate}
                    bind={this.criteria.meta.date}
                    dateProps={{ formatString: "dd MMM yyyy HH:mm" }}
                    appendText="fa-calendar"/>
            </Neo.GridLayout>
        </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}